import React from "react";

import "./main.scss";
import logo from "../../assets/img/pawscars/logo.png";
import bg from "../../assets/img/pawscars/bg.png";

function PawScars() {
  return (
    <>
      <div class="paw-scars">
        <img class="bg-paw-scars" src={bg} />
        <section class="pawscars-content">
          <div class="intro">
            <img src={logo} alt="Pawscars Logo" class="pawscars-logo" />
          </div>

          <div class="join-us-pawscars">
            <div>
              <p class="intro-description">
                Lights, camera... paws!
                <br />
                It’s time to tell the world your story—with your
                <br />
                furry stars leading the way!
              </p>
            </div>

            <div>
              <h2>Join Us!</h2>
              <p class="cta-text">
                Interested? Get started by downloading our PDF file below!
                <br />
                We can’t wait for you to tell us your story!
              </p>
              <div class="button-container">
                <a
                  href="assets/pdfs/how-to-join.pdf"
                  class="download-btn special"
                  download
                >
                  <svg
                    width="40"
                    height="29"
                    viewBox="0 0 40 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.8034 1.25H38.1001M11.8034 14.48H38.1001M11.8034 27.71H38.1001M1.3501 1.25V1.27613M1.3501 14.48V14.5061M1.3501 27.71V27.7361"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Download <br /> full mechanics
                </a>
                <a
                  href="assets/pdfs/registration-form.pdf"
                  download
                  class="download-btn special"
                >
                  <svg
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.875 21.6667L11.6563 27.303M16.5 32H32M3.90625 21.6667L23.009 2.49587C25.0658 0.50138 28.4006 0.501375 30.4574 2.49586C32.5142 4.49036 32.5142 7.72407 30.4574 9.71856L10.6875 28.2424L1 31.0606L3.90625 21.6667Z"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Download <br /> registration form
                </a>
                <a
                  href="assets/pdfs/submission-form.pdf"
                  download
                  class="download-btn special"
                >
                  <svg
                    width="38"
                    height="37"
                    viewBox="0 0 38 37"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.7505 3.69995V9.24995C23.7505 10.2717 24.6012 11.1 25.6505 11.1H31.3505M28.5005 6.47495C27.6549 5.73825 26.7774 4.86449 26.2234 4.29701C25.8548 3.91938 25.3455 3.69995 24.8104 3.69995H10.45C8.35138 3.69995 6.65006 5.35649 6.65005 7.39993L6.6499 29.5998C6.64989 31.6433 8.3512 33.2999 10.4499 33.2999L27.55 33.2999C29.6486 33.2999 31.3499 31.6434 31.35 29.6L31.3505 9.98661C31.3505 9.51356 31.1652 9.05884 30.828 8.71828C30.2045 8.08853 29.1632 7.05233 28.5005 6.47495Z"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Download <br /> submission form
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default PawScars;
